import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges, OnChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-validation-container',
  templateUrl: './validation-container.component.html',
  styleUrls: ['./validation-container.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule,
  ],
})
export class ValidationContainerComponent implements OnChanges {
  errorMessages: any[];
  warningMessages: any[];
  infoMessages: any[];

  @Input() messages: any[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.messages && changes.messages.currentValue) {
      this.errorMessages = changes.messages.currentValue.filter(
        m => !!m.type && m.type.toLowerCase().indexOf('exception') !== -1,
      );
      this.warningMessages = changes.messages.currentValue.filter(
        m => !!m.type && m.type.toLowerCase() === 'warning',
      );
      this.infoMessages = changes.messages.currentValue.filter(
        m => !!m.type && m.type.toLowerCase() === 'info',
      );
    }
  }
}
